import { API_VERSION, HOME_SERVICE, X_API_VERSION } from "../../../constants";
import { apiOptions, apiRequest } from "../../../utils";

const API_HOMES = `${HOME_SERVICE}/series`;

export const series = {
  getAll: async ({ filters, sort, params, signal } = {}) => {
    const options = await apiOptions({
      url: API_HOMES,
      method: "get",
      headers: { [X_API_VERSION]: API_VERSION },
      signal,
      params,
      filters,
      sort,
    });
    return apiRequest(options);
  },
  getById: async ({ id, signal }) => {
    const options = await apiOptions({
      url: `${API_HOMES}/${id}`,
      method: "get",
      headers: { [X_API_VERSION]: API_VERSION },
      signal,
    });
    return apiRequest(options);
  },
  create: async ({ data, toastMessageConfig }) => {
    const options = await apiOptions({
      url: API_HOMES,
      method: "post",
      headers: { [X_API_VERSION]: API_VERSION },
      data,
    });
    return apiRequest(options, toastMessageConfig);
  },
  update: async ({ data, toastMessageConfig, signal }) => {
    const options = await apiOptions({
      url: `${API_HOMES}/${data.id}`,
      method: "patch",
      headers: { [X_API_VERSION]: API_VERSION },
      data,
      signal,
    });
    return apiRequest(options, toastMessageConfig);
  },
  delete: async ({ id, modifiedOn, toastMessageConfig }) => {
    const options = await apiOptions({
      url: `${API_HOMES}/${id}`,
      method: "delete",
      headers: { [X_API_VERSION]: API_VERSION },
      data: { modifiedOn },
    });
    return apiRequest(options, toastMessageConfig);
  },
  specLevel: {
    getSuggestions: async ({ searchText, accountId } = {}) => {
      const options = await apiOptions({
        url: `${API_HOMES}/suggestions/spec-level/`,
        method: "get",
        headers: { [X_API_VERSION]: API_VERSION },
        params: {
          searchText,
          accountId,
        },
      });
      return apiRequest(options);
    },
  },
};
